import { useEffect, useRef, useState } from "react";

// ASSETS
import ArrowDown from "assets/svg/ArrowDownYellow.svg";

// MISC
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";

// REDUX
import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// STYLES
import {
  DropdownContainer,
  DropdownContent,
  DropdownContentContainer,
  DropdownHeader,
  DropdownIcon,
  DropdownList,
  DropdownListElement,
  SettingLabel,
} from "view/CookieModule/CookieModuleStyled";

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";
import CustomCheckbox from "../CustomCheckbox/CustomCheckbox";

const CustomCookiesDropdown = ({
  title,
  description,
  items,
  onItemsChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [itemStates, setItemStates] = useState(items);
  const [allChecked, setAllChecked] = useState(false);

  // LIBRARY CONSTANTS
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleMasterCheckboxChange = () => {
    const newAllChecked = !allChecked;
    setAllChecked(newAllChecked);
    const newItems = itemStates.map((item) => ({
      ...item,
      checked: newAllChecked,
    }));
    setItemStates(newItems);
    onItemsChange(newItems);
  };

  const handleCheckboxChange = (index) => {
    const newItems = [...itemStates];
    newItems[index].checked = !newItems[index].checked;
    setItemStates(newItems);
    onItemsChange(newItems);

    const allChecked = newItems.every((item) => item.checked);
    setAllChecked(allChecked);
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  useEffect(() => {
    const allChecked = itemStates.every((item) => item.checked);
    setAllChecked(allChecked);
  }, [itemStates]);

  return (
    <div ref={dropdownRef}>
      <DropdownContainer
        biggerCursor={biggerCursor}
        onClick={toggleDropdown}
        isOpen={isOpen}
      >
        <DropdownHeader>
          <SettingLabel>
            <CustomText type={TextType.P1} text={title} color={COLORS.Orange} />
            <CustomCheckbox
              checked={allChecked}
              onChange={handleMasterCheckboxChange}
              isDisabled={title === "Necesare" || title === "Necessary"}
            />
          </SettingLabel>
          <DropdownIcon src={ArrowDown} alt="Details arrow" isOpen={isOpen} />
        </DropdownHeader>
      </DropdownContainer>
      <DropdownContentContainer isOpen={isOpen}>
        <DropdownContent>
          <CustomText
            type={TextType.P2}
            text={description}
            color={COLORS.Cultured}
          />
          <DropdownList>
            {/* {itemStates.map((item, index) => (
                            <DropdownListElement key={index}>
                                <SettingLabel>
                                    {item.title}
                                    <CustomCheckbox
                                        checked={item.checked}
                                        onChange={() => handleCheckboxChange(index)}
                                    />
                                </SettingLabel>
                                <CustomText
                                    type={TextType.P2}
                                    text={item.description}
                                    color={COLORS.WhiteSmoke}
                                />
                            </DropdownListElement>
                        ))} */}
          </DropdownList>
        </DropdownContent>
      </DropdownContentContainer>
    </div>
  );
};

export default CustomCookiesDropdown;
